/*
 * SPDX-FileCopyrightText: 2023 SAVIA Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const customerTicketing = {
  customerTicketing: {
    mainLogoLabel: 'SAVIA',
    mainTitle: 'Emisión de tickets de clientes',
    ticketId: 'IDENTIFICACIÓN',
    createdOn: 'Creado el',
    changedOn: 'Modificado en',
    category: 'Categoría',
    associatedTo: 'Asociado a',
    ticketPurchaseOrderNumber: 'Numero del pedido',
    optionalField: '(opcional)',
    status: 'Estado',
    message: 'Mensaje',
    cancel: 'Cancelar',
    submit: 'Enviar',
    uploadFile: 'Subir archivo',
    fileSizeLimit: 'Límite de tamaño de archivo: {{count}} MB',
    maximumAttachment: 'Máximo de un archivo adjunto por mensaje',
    errorMensaje: 'Algo salió mal.',
    charactersLeft: 'Caracteres a la izquierda: {{count}}',
    customerService: 'Servicio al cliente',
  },
  customerTicketingList: {
    ticketCategory: 'Categoría',
    subject: 'Asunto',
    ticketCategoría: 'Categoría',
    sortSubtitle: 'Ordenar por',
    sortOrders: 'Criterios de clasificación',
    noTickets: `No tienes ninguna solicitud`,
    requestTitle: 'Todas las solicitudes',

    mobile: {
      ticketIdFull: 'Ticket IDENTIFICACIÓN',
    },
  },
  createCustomerTicket: {
    createNewTicket: 'Agregar',
    addRequest: 'Agregar Nueva Solicitud',
    subject: 'Asunto',
    category: 'Categoría',
    associateTo: 'Asociar a',
    ticketCreated: 'Solicitud creada.',
    optionallySelectAssociatedObject: 'Seleccionar Opción',
    selectCategory: 'Seleccionar Categoría',
  },
  customerTicketingDetails: {
    requestReopened: 'Solicitud reabierta.',
    requestClosed: 'Solicitud cerrada, puede volver a abrir si es necesario.',
    reopenRequest: 'Solicitud de reapertura',
    closeRequest: 'Cerrar solicitud',
    ticketNotFound: 'Ticket no encontrado.',
  },
};
